function getConfig(name, defaultValue = null) {
    // If inside a docker container, use window.ENV
    if (window.ENV !== undefined) {
        return window.ENV[name] || defaultValue;
    }

    return process.env[name] || defaultValue;
}

export function getBackendUrl() {
    return getConfig('REACT_APP_BACKEND_URL');
}

export function getHoursCloseTicketsAuto() {
    return getConfig('REACT_APP_HOURS_CLOSE_TICKETS_AUTO');
}

export function getFrontendPort() {
    return getConfig('SERVER_PORT');
}

export function getPrimaryColor() {
    return getConfig("REACT_APP_PRIMARY_COLOR");
}

export function getPrimaryDark() {
    return getConfig("REACT_APP_PRIMARY_DARK");
}

export function getNumberSupport() {
    return getConfig("REACT_APP_NUMBER_SUPPORT");
}

export const DEFAULT_APP_NAME = "NaviChats";

const LEGACY_APP_NAMES = new Set([
    "CRM Atenciones",
    "NaviCRM",
    "NaviChat",
    "Multi100",
    "Multizap Flow",
]);

export const resolveAppName = (name) => {
    const trimmed = String(name || "").trim();
    if (!trimmed || LEGACY_APP_NAMES.has(trimmed)) {
        return DEFAULT_APP_NAME;
    }
    return trimmed;
};